var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SkeletonAnimation',[_c('div',{staticClass:"efocate-skeleton-component"},[_c('div',{staticClass:"cate-container"},[_c('div',{staticClass:"back"}),_c('div',{staticClass:"banner"},[_c('PartItem',{attrs:{"styles":{
            width: '620px',
            height: '40px',
            'border-radius': '4px',
            'margin-bottom': '20px',
            'margin-top': '100px',
          }}}),_c('PartItem',{attrs:{"styles":{
            width: '260px',
            height: '24px',
            'border-radius': '4px',
          }}})],1),_vm._l((10),function(index){return _c('div',{key:index,staticClass:"cate-list"},[_c('PartItem',{attrs:{"styles":{
            width: '200px',
            height: '200px',
            'border-radius': '4px',
            'margin-bottom': '16px',
          }}}),_c('PartItem',{attrs:{"styles":{
            width: '200px',
            height: '16px',
            'border-radius': '4px',
            'margin-bottom': '10px',
          }}}),_c('div',{staticClass:"flex"},[_c('PartItem',{attrs:{"styles":{
              width: '100px',
              height: '15px',
              'border-radius': '4px',
            }}}),_c('PartItem',{attrs:{"styles":{
              width: '72px',
              height: '32px',
              'border-radius': '4px',
              'margin-bottom': '16px',
            }}})],1),_c('div',{staticClass:"line"}),_c('PartItem',{attrs:{"styles":{
            width: '200px',
            height: '12px',
            'border-radius': '4px',
          }}})],1)})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }